export function aggregateHeatmapPoints(points = [], {
  cellSize = 32,
  maxFeatures = 2500
} = {}) {
  const validPoints = (points || [])
    .map(point => ({
      ...point,
      x: Number(point.x),
      y: Number(point.y),
      weight: Math.max(0, Math.min(1, Number(point.weight) || 0))
    }))
    .filter(point => Number.isFinite(point.x) && Number.isFinite(point.y));

  if (!validPoints.length || validPoints.length <= maxFeatures) {
    return validPoints;
  }

  let currentCellSize = Math.max(Number(cellSize) || 0, 1);
  let aggregated = [];

  for (let attempt = 0; attempt < 4; attempt += 1) {
    aggregated = aggregatePointsForCellSize(validPoints, currentCellSize);
    if (aggregated.length <= maxFeatures) {
      break;
    }
    currentCellSize *= 1.6;
  }

  return aggregated;
}

function aggregatePointsForCellSize(points, cellSize) {
  const buckets = new Map();

  points.forEach(point => {
    const key = `${Math.floor(point.x / cellSize)}:${Math.floor(point.y / cellSize)}`;
    const bucket = buckets.get(key) || {
      id: `heatmap-cell-${key}`,
      type: point.type,
      weightedX: 0,
      weightedY: 0,
      totalWeight: 0,
      count: 0
    };
    const weight = point.weight || 0.01;
    bucket.weightedX += point.x * weight;
    bucket.weightedY += point.y * weight;
    bucket.totalWeight += weight;
    bucket.count += 1;
    buckets.set(key, bucket);
  });

  return Array.from(buckets.values()).map(bucket => ({
    id: bucket.id,
    type: bucket.type,
    x: bucket.weightedX / bucket.totalWeight,
    y: bucket.weightedY / bucket.totalWeight,
    weight: Math.min(1, bucket.totalWeight / Math.max(1, Math.sqrt(bucket.count))),
    count: bucket.count
  }));
}
